export default {
    props: {
        messagesYear: {
            type: String,
            default: undefined,
            kComposite: 'messages.year'
        }, 
        messagesMonth: {
            type: String,
            default: undefined,
            kComposite: 'messages.month'
        }, 
        messagesDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.day'
        }, 
        messagesWeekday: {
            type: String,
            default: undefined,
            kComposite: 'messages.weekday'
        }, 
        messagesHour: {
            type: String,
            default: undefined,
            kComposite: 'messages.hour'
        }, 
        messagesMinute: {
            type: String,
            default: undefined,
            kComposite: 'messages.minute'
        }, 
        messagesSecond: {
            type: String,
            default: undefined,
            kComposite: 'messages.second'
        }, 
        messagesDayperiod: {
            type: String,
            default: undefined,
            kComposite: 'messages.dayperiod'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateInput/Messages.js